function initPfh(root) {
  if (root.dataset.pfhInit) return;
  var drawer = document.getElementById(root.getAttribute('data-pfh-drawer-id'));
  root.dataset.pfhInit = '1';

  /* ---------- Desktop mega panel ---------- */
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-pfh-tab]'));
  var openTimer, closeTimer, current = null;

  function openItem(item) {
    clearTimeout(closeTimer);
    if (current && current !== item) closeItem(current);
    item.classList.add('is-open');
    item.querySelector('[data-pfh-tab-btn]').setAttribute('aria-expanded', 'true');
    current = item;
    root.classList.add('has-open');
  }
  function closeItem(item) {
    item.classList.remove('is-open');
    item.querySelector('[data-pfh-tab-btn]').setAttribute('aria-expanded', 'false');
    if (current === item) current = null;
    root.classList.toggle('has-open', !!current);
  }
  function closeAll() { items.forEach(closeItem); }

  items.forEach(function (item) {
    var btn = item.querySelector('[data-pfh-tab-btn]');
    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () { openItem(item); }, 60);
    });
    item.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { closeItem(item); }, 140);
    });
    btn.addEventListener('click', function () {
      if (item.classList.contains('is-open')) closeItem(item); else openItem(item);
    });
  });
  root.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeAll, 140); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeDrawer(); } });
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(); });

  /* Scroll: shadow / transparent state, and hide-on-scroll-down / show-on-scroll-up */
  var hideOnScroll = root.getAttribute('data-pfh-hide-on-scroll') === 'true';
  var lastY = window.scrollY;
  function onScroll() {
    var y = window.scrollY;
    root.classList.toggle('is-scrolled', y > 4);
    if (hideOnScroll) {
      var delta = y - lastY;
      var drawerOpen = drawer && drawer.classList.contains('is-open');
      if (y <= 4 || current || drawerOpen) {
        root.classList.remove('is-hidden');
      } else if (delta > 2 && y > root.offsetHeight + 60) {
        root.classList.add('is-hidden');
      } else if (delta < -2) {
        root.classList.remove('is-hidden');
      }
      lastY = y;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Mobile drawer ---------- */
  var burger = root.querySelector('[data-pfh-open]');
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('pfh-lock');
    setTimeout(function () { drawer.classList.add('is-visible'); }, 20);
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-visible');
    burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('pfh-lock');
    setTimeout(function () {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.querySelectorAll('.pfh-pane--sub.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    }, 300);
  }
  if (burger) burger.addEventListener('click', openDrawer);
  if (drawer) {
    drawer.querySelectorAll('[data-pfh-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });

    drawer.querySelectorAll('[data-pfh-tab-switch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-pfh-tab-switch');
        drawer.querySelectorAll('[data-pfh-tab-switch]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        drawer.querySelectorAll('[data-pfh-tab-pane]').forEach(function (p) {
          var on = p.getAttribute('data-pfh-tab-pane') === id;
          p.classList.toggle('is-active', on);
          if (!on) p.querySelectorAll('.pfh-pane--sub.is-open').forEach(function (s) { s.classList.remove('is-open'); });
        });
      });
    });

    drawer.addEventListener('click', function (e) {
      var open = e.target.closest('[data-pfh-sub-open]');
      if (open) {
        var pane = drawer.querySelector('[data-pfh-sub="' + open.getAttribute('data-pfh-sub-open') + '"]');
        if (pane) { pane.classList.add('is-open'); pane.scrollTop = 0; }
        return;
      }
      var back = e.target.closest('[data-pfh-sub-close]');
      if (back) back.closest('.pfh-pane--sub').classList.remove('is-open');
    });
  }

  /* Theme editor: open the panel of the selected block */
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest && e.target.closest('[data-pfh-tab]');
    if (item && root.contains(item)) openItem(item);
  });
  document.addEventListener('shopify:block:deselect', function () { closeAll(); });
}

function initAllPfh() { document.querySelectorAll('[data-pfh]').forEach(initPfh); }
initAllPfh();
document.addEventListener('shopify:section:load', initAllPfh);
